module.exports = __webpack_public_path__ + "img/facebook.e4da2370.png";